import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Row } from '@prisjakt/ui/list/variants';

export const AppliedFilters = styled(Row)`
  margin-top: ${layout.measurements.spacing050};
  align-items: center;

  ${media.largeUp`
    margin-top: 0;
  `}
`;

export const AppliedFiltersTitle = styled.span`
  white-space: nowrap;
`;
